import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { ModalService } from '../shared/modal/modal.service';
import { GlobalService } from '../services/global.service';
import { SnackBarService } from '../shared/snackbar/snackbar.service';

import { AddCategoryComponent } from '../shared/modal/add-category/add-category.component'
import { UploadDocumentComponent } from '../shared/modal/upload-document/upload-document.component'
import { BasicQuestionComponent } from '../shared/modal/basic-question/basic-question.component';

import Utils from '../shared/utility';

@Component({
  selector: 'app-marketing-material',
  templateUrl: './marketing-material.component.html',
  styleUrls: ['./marketing-material.component.css']
})
export class MarketingMaterialComponent implements OnInit {
  public healthCareMaterial: any[];
  public longTermCareMaterial: any[];
  public socialSecurityMaterial: any[];

  public articlesForClients: any[];
  public clientLetters: any[];
  public educationalWorkshops: any[];
  public factGuides: any[];
  public otherAdvertising: any[];
  public websiteArtwork: any[];

  public marketingMaterialArr: any[];

  public toggleInput: any;

  public selectedCategory: any;
  public selectedDescription: any;
  public selectedTitle: any;

  public selectedInputs: any = {};

  public error: any;

  public droppedData: any = {};

  // TODO: REMOVE THIS LATER
  public visible: boolean = false;

  public modalSubscription: any;

  public categories: any;

  constructor(private matDialog: MatDialog, private modalService: ModalService, private globalService: GlobalService, private snackBarService: SnackBarService) {
    this.modalSubscription = modalService.modal$.subscribe((modal) => {
      if (modal.modalName == 'upload-docClosed') {
        this.getMM();
      }
    });
  }

  toggleModal(modalName): void {
    if (modalName == 'add-category') {
      const dialogRef = this.matDialog.open(AddCategoryComponent, {
        data: { docArr: this.marketingMaterialArr, type: 'marketing-material' }
      });
    }

    if (modalName == 'upload-document') {
      const dialogRef = this.matDialog.open(UploadDocumentComponent, {
        data: { categories: this.categories, docArr: this.marketingMaterialArr, type: 'marketing-material' }
      });

      dialogRef.afterClosed().subscribe(result =>{
        this.getMM();
      });
    }
  }

  editCategory(catIdx, val) {

    const dialogRef = this.matDialog.open(AddCategoryComponent, {
      data: { docArr: this.marketingMaterialArr, value: val, type: 'marketing-material' }
    });

    dialogRef.afterClosed().subscribe(result =>{
      if(result.saved){
        if(result.delete){
          this.deleteCategory(val, catIdx);
        } else {
          this.selectedInputs[catIdx].category = false;
          this.marketingMaterialArr[catIdx].category = result.value;//this.selectedCategory;
          this.saveMM();
        }
      }
    });
  }

  deleteCategory(cat, index){
    this.selectedMaterial = {
      category: cat,
      index,
    }

    this.confirmCategoryDeleteVisible = true;
    this.marketingMaterialArr.splice(this.selectedMaterial.index, 1);
    const oldFormat = Utils.convertMarketingMaterialOrInfoCenterToOldFormat(this.marketingMaterialArr);

    this.globalService.ReplaceMarketingMaterial(oldFormat)
      .subscribe(
        resp => {
          if (resp) {
            this.snackBarService.add('Category and documents have been removed', 0);
          } else {
            this.snackBarService.add('An error occurred - please contact support', 1);
          }
          //this.confirmDeleteVisible = false;
        },
        error => this.error = <any>error);
  }

  deleteDoc() {
    this.marketingMaterialArr[this.selectedMaterial.i].items.splice(this.selectedMaterial.j, 1);
    const oldFormat = Utils.convertMarketingMaterialOrInfoCenterToOldFormat(this.marketingMaterialArr);
    this.globalService.ReplaceMarketingMaterial(oldFormat)
      .subscribe(
        resp => {
          if (resp) {
            this.snackBarService.add('Document has been removed', 0);
          } else {
            this.snackBarService.add('An error occurred - please contact support', 1);
          }
          //this.confirmDeleteVisible = false;
        },
        error => this.error = <any>error);
  }

  public confirmDeleteVisible: boolean;
  public confirmCategoryDeleteVisible: boolean;
  public selectedMaterial: any;

  deleteItem(item, i, j) {
    this.selectedMaterial = {
      item,
      i,
      j
    }

    const dialogRef = this.matDialog.open(BasicQuestionComponent, {     
      data: { title: 'Removing a Document', question: 'Are you sure you want to remove the document titled: <b>' + item.Title + '</b>?<br/><b>This cannot be undone</b>.' }
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        this.deleteDoc();
      }
    });
  }

  enableUploadDoc: boolean = true;
  getMM() {
    this.globalService.GetMarketingMaterial()
      .subscribe(
        data => {
          
          let documents = Utils.convertMarketingMaterialOrInfoCenterToNewFormat(JSON.parse(data.data));
          
          let uniqueDocumentCategories = documents.reduce((obj, item) => {
            if (!obj[item.Category])
              obj[item.Category] = item.Category;
            return obj;
          }, {});

          this.categories = Object.keys(uniqueDocumentCategories).map((category, i) => category);

          this.marketingMaterialArr = [];
          this.droppedData = {};
          
          Object.keys(uniqueDocumentCategories).forEach((category, i) => {
            this.marketingMaterialArr.push({
              category: category,
              items: documents.filter(doc => doc.Category === category),
            });
            if (this.marketingMaterialArr[this.marketingMaterialArr.length - 1].items[0] && (!this.marketingMaterialArr[this.marketingMaterialArr.length - 1].items[0].Title || !this.marketingMaterialArr[this.marketingMaterialArr.length - 1].items[0].Description)) {
              if (this.marketingMaterialArr[this.marketingMaterialArr.length - 1].items.length > 1) {
                this.marketingMaterialArr[this.marketingMaterialArr.length - 1].items.splice(0, 1);
              }
            }
          });

          if(this.marketingMaterialArr.length == 0){
            this.enableUploadDoc = false;
          }

          this.generateSelectedInputs();
        },
        error => this.error = <any>error);
  }

  generateSelectedInputs() {
    this.selectedInputs = {};

    Object.keys(this.marketingMaterialArr).forEach((cat, i) => {
      this.selectedInputs[i] = { category: false }
    });

    this.marketingMaterialArr.forEach((cat, i) => {
      cat.items.forEach((doc, j) => {
        this.selectedInputs[i][j] = { title: false, description: false }
      });
    });
  }

  saveMM() {

    const oldFormat = Utils.convertMarketingMaterialOrInfoCenterToOldFormat(this.marketingMaterialArr);

    this.globalService.ReplaceMarketingMaterial(oldFormat)
      .subscribe(
        resp => {
          if (resp) {
            this.snackBarService.add('Your document has been updated', 0);
          } else {
            this.snackBarService.add('An error occurred - please contact support', 1);
          }
          this.confirmDeleteVisible = false;
        },
        error => this.error = <any>error);
  }

  public userType: any;
  public rootLevelOrganization:  boolean;

  ngOnInit() {
    this.userType = Number(localStorage.getItem('roleId')) || 3;
    this.visible = (Number(localStorage.getItem('orgID')) === 2 || Number(localStorage.getItem('parentID')) === 2) ? true : false;
    this.rootLevelOrganization = (Number(localStorage.getItem('parentID')) == 0) && (Number(localStorage.getItem('roleId')) == 1 || Number(localStorage.getItem('roleId')) == 2);
    
    this.toggleInput = {
      category: {},
      title: {},
      description: {},
    }

    this.getMM();
  }


  public addCategoryVisible: boolean = false;
  public newCategory: string = '';

  onDrop(event, catIdx, docIdx) {

    if (!this.parentTableTriggered && catIdx === event.dropData.catIdx) {
      var fromDoc = this.marketingMaterialArr[event.dropData.catIdx].items[event.dropData.docIdx];
      var toDoc = this.marketingMaterialArr[catIdx].items[docIdx];
      this.marketingMaterialArr[event.dropData.catIdx].items[event.dropData.docIdx] = toDoc;
      this.marketingMaterialArr[catIdx].items[docIdx] = fromDoc;
    }

    this.parentTableTriggered = false;

    this.generateSelectedInputs();
    this.saveMM();
  }

  public parentTableTriggered: boolean = false;
  public triggeredIndex: any = 0;

  onDropTable(event, catIdx, docIdx) {
    this.marketingMaterialArr[event.dropData.catIdx].items.splice(event.dropData.docIdx, 1);
    this.marketingMaterialArr[catIdx].items.push(event.dropData.item);

    if (!this.marketingMaterialArr[catIdx].items[0].Title || !this.marketingMaterialArr[catIdx].items[0].Description) {
      this.marketingMaterialArr[catIdx].items.splice(0, 1);
      this.parentTableTriggered = true;
    }

    this.generateSelectedInputs();
    this.saveMM();
  }
}
